import { initialState } from "./state"
import { mutations } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export default {
  ...mutations,
  updateUuid: (state, payload) => (state.uuid = payload),
  updateIsEditing: (state, payload) => (state.isEditing = payload),
  updateCurrentStep: (state, payload) => (state.currentStep = payload),
  updateTenant: (state, payload) => (state.tenant = { ...state.tenant, ...payload }),
  updateLoading: (state, payload) => (state.loading = {...state.loading, ...payload}),
  resetTenant: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },
  setPaymentTypesOptions: (state, payload) => (state.paymentTypesOptions = payload), 
  setShippingMethodsOptions: (state, payload) => (state.shippingMethodsOptions = payload) 
}
